import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
import { USE_RETRIEVE_DIVISION, USE_RETRIEVE_DIVISIONS_BY_SEASON_ID, } from "./queryKeys";
export const useRetrieveDivisionsBySeasonId = ({ seasonId, enabled = true, }) => {
    return useQuery({
        queryKey: [USE_RETRIEVE_DIVISIONS_BY_SEASON_ID, seasonId],
        queryFn: async () => {
            const { data } = await api.get(`/seasons/${seasonId}/divisions/`);
            return data;
        },
        enabled: !!seasonId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useRetrieveDivision = ({ id, enabled = true, }) => {
    return useQuery({
        queryKey: [USE_RETRIEVE_DIVISION, id],
        queryFn: async () => {
            const { data } = await api.get(`/divisions/${id}/`);
            return data;
        },
        enabled: !!id && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useCreateDivision = ({ onMutate, onSuccess, onError, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => {
            return api.post(`/divisions/`, data);
        },
        onMutate,
        onSuccess: (data) => {
            const division = data.data;
            const seasonId = division.season;
            queryClient.invalidateQueries([
                USE_RETRIEVE_DIVISIONS_BY_SEASON_ID,
                seasonId,
            ]);
            onSuccess(data);
        },
        onError,
    });
};
export const useUpdateDivision = ({ onMutate, onSuccess, onError, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => {
            return api.put(`/divisions/${data.id}/`, data);
        },
        onMutate,
        onSuccess: (data) => {
            const division = data.data;
            const seasonId = division.season;
            queryClient.invalidateQueries([USE_RETRIEVE_DIVISION, division.id]);
            queryClient.invalidateQueries([
                USE_RETRIEVE_DIVISIONS_BY_SEASON_ID,
                seasonId,
            ]);
            onSuccess?.(data);
        },
        onError,
    });
};
export const useDeleteDivision = ({ onMutate, onSuccess, onError, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id }) => {
            return api.delete(`/divisions/${id}/`);
        },
        onMutate,
        onSuccess: (_, { id, seasonId }) => {
            queryClient.removeQueries([USE_RETRIEVE_DIVISION, id]);
            queryClient.invalidateQueries([
                USE_RETRIEVE_DIVISIONS_BY_SEASON_ID,
                seasonId,
            ]);
            onSuccess?.();
        },
        onError,
    });
};
